<template>
  <svg class="icon" width="34" height="42" viewBox="0 0 34 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.671183 26.1205L15.2546 40.7039C16.1495 41.5989 17.6005 41.5989 18.4954 40.7039L33.0788 26.1205C33.9737 25.2256 33.9737 23.7747 33.0788 22.8798C32.1839 21.9848 30.733 21.9848 29.8381 22.8798L19.1666 33.5512L19.1666 2.41852C19.1666 1.15292 18.1406 0.126954 16.875 0.126954C15.6094 0.126954 14.5834 1.15292 14.5834 2.41852L14.5834 33.5512L3.91195 22.8798C3.01703 21.9848 1.5661 21.9848 0.671183 22.8798C-0.223729 23.7747 -0.223729 25.2256 0.671183 26.1205Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconArrowBottom'
}
</script>
